import React, { useEffect, useRef, useState } from 'react';

function TextInput(props: any) {
    const [show, setShow] = useState(false);
    const [inputVal, setInputVal] = useState('');
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [passwordVisible, setpasswordVisible] = useState(true);
    const [inputType, setinputType] = useState('text');

    const validate = (res: any) => {
        try {
            let data = res;
            if (props.data?.type == 'number' || props.data?.type == 'Number') {
                data = res.replace(/\D/g, '');
            }

            const placeholder = props?.data?.placeholder.toLowerCase() || null;

            // //console.log('data', data)
            if (props?.inputProps?.[props.controlName]?.required && data.trim()?.length == 0) {
                // console.log('000000');

                hideShowError(true);
                setErrorMsg(`Field is required`);
                props.setValue({ [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '' });
            } else if (data?.length > 0 && props?.inputProps?.[props.controlName]?.pattern) {
                const regmob = new RegExp(props?.inputProps?.[props.controlName]?.pattern);
                // //////console.log("regmob", regmob.test(data), props?.inputProps?.[props.controlName]?.pattern)
                // console.log('11111111', regmob.test(data));

                if (regmob.test(data) == false) {
                    setErrorMsg(`Invalid ${placeholder || props?.data.name}`); //`${props?.data.name} is invalid. Please enter valid data`
                    // props.setValue({
                    //     [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '',
                    // });
                    // props.setValue({
                    //     ['state']: '',
                    // });

                    hideShowError(true);
                    // props.setErrorField(props.controlName);
                    props.setValue({ [props.controlName]: data.trim() });
                } else {
                    setErrorMsg('');
                    hideShowError(false);
                    props.setValue({ [props.controlName]: data.trim() });
                }
            } else if (props.controlName == 'confirmpassword' && !confirmPasswordValidator(data)) {
                // console.log('222222');
                hideShowError(true);
                setErrorMsg(`Passwords do not match`);
                props.setValue({ [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '' });
            } else {
                // console.log('333333');
                hideShowError(false);
                props.setValue({ [props.controlName]: data.trim() });
            }
            // props.setValue({ [props.controlName]: data })
            setInputVal(data);
        } catch (error) {}
    };

    useEffect(() => {
        if (!show) {
            setShow(props.isSubmit);
        }
        const d = props?.value?.toString().trim() || inputVal?.toString().trim() || null;
        const data = { [props.controlName]: props?.inputProps?.[props.controlName]?.required ? (d ? d : null) : d };
        props.setValue(data);

        const inputValStr: any = inputVal ? inputVal.toString().trim() : null;
        // //console.log('inputVal TextInput', props.controlName, d, inputValStr, inputValStr?.length, checkInputVali())
        if (inputValStr?.length > 0) {
            hideShowError(checkInputVali());
        }
    }, [props.isSubmit]);

    const checkInputVali = () => {
        try {
            // const d = props?.value?.toString() || inputVal ? props?.value?.toString() || inputVal.toString() : null;
            const d = props?.value?.toString().trim() || inputVal?.toString().trim() || null;
            const inputValStr: any = inputVal ? inputVal.toString() : null;
            if (props?.inputProps?.[props.controlName]?.pattern) {
                const regmob = new RegExp(props?.inputProps?.[props.controlName]?.pattern);
                // //console.log('inputVal---', props.controlName, d, inputValStr, regmob.test(inputValStr))
                if (!regmob.test(inputValStr)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            //console.log('error, error');
            return false;
        }
    };

    useEffect(() => {
        const erMsg = props?.inputProps?.[props.controlName]?.message || null;

        const str = props?.value?.toString() || null;
        // //console.log('inputVal   TextInput--------', str, props?.inputProps?.[props.controlName]?.error)
        if (str?.trim()?.length == 0) {
            return;
        }
        setErrorMsg(erMsg);
        setError(props?.inputProps?.[props.controlName]?.error);
    }, [props.inputProps]);

    useEffect(() => {
        // //console.log('00000', props?.value)
        const str = props?.value?.toString();
        setInputVal(str);
    }, [props.value]);

    const hideShowError = (flag: boolean) => {
        try {
            // //console.log('#########', flag)
            setShow(flag);
            setError(flag);
        } catch (error) {}
    };

    const confirmPasswordValidator = (confirmPass: any) => {
        if (confirmPass !== props.formData?.password) {
            return false;
        }
        return true;
    };

    useEffect(() => {
        setinputType(props.data?.type);
    }, [props.data?.type]);

    const togglePasswordVisibility = () => {
        try {
            const type = !passwordVisible ? 'password' : 'text';
            setpasswordVisible(!passwordVisible);
            setinputType(type);
        } catch (error) {}
    };

    return (
        <React.Fragment>
            {/* <div>{(error) ? 'true' : 'false'} {(show) ? 'true' : 'false'} {inputVal?.length || 0}</div> */}
            <div className="form-group">
                <div className="form-floating">
                    {inputType == 'textarea' ? (
                        <textarea
                            className="form-control"
                            id={props.data?.id}
                            style={{ height: '100px' }}
                            disabled={props.disabled}
                            name={props.data?.name || ''}
                            placeholder={props.data?.placeholder || ''}
                            ref={inputRef}
                            onChange={e => {
                                validate(e.target.value);
                            }}
                            value={inputVal}
                            {...props?.inputProps?.[props.controlName]}
                            {...props?.style}
                        ></textarea>
                    ) : (
                        <input
                            className={`form-control txt-cap-sel ${props.data?.type == 'password' ? 'pos-rel' : null}`}
                            id={props.data?.id}
                            type={inputType == 'number' || inputType == 'Number' ? 'text' : inputType || 'text'}
                            name={props.data?.name || ''}
                            placeholder={props.data?.placeholder || ''}
                            ref={inputRef}
                            onChange={e => {
                                validate(e.target.value);
                            }}
                            value={inputVal}
                            readOnly={props?.readOnly ? true : false}
                            {...props?.inputProps?.[props.controlName]}
                            {...props?.style}
                        />
                    )}
                    {props.data?.type == 'password' && (
                        <div className="input-group-addon passview" onClick={togglePasswordVisibility}>
                            <i className={`fa fa-eye${passwordVisible ? '-slash' : ''}`} aria-hidden="true"></i>
                        </div>
                    )}
                    {(props.data?.type == 'date' || props.data?.type == 'datetime-local') && (
                        <div className="input-group-addon passview">
                            <i className={`fa fa-calendar`} aria-hidden="true"></i>
                        </div>
                    )}

                    {props.data?.id !== '' ? (
                        <label className="labeltext" htmlFor={props.data?.id}>
                            {props.data?.placeholder}
                            {props?.inputProps?.[props.controlName]?.required ? (
                                <sup className={inputType == 'textarea' ? 'textarea-red' : `text-red`}>*</sup>
                            ) : (
                                ''
                            )}
                        </label>
                    ) : (
                        ''
                    )}
                </div>
                {/* inputRef?.current?.value?.length == 0 && */}

                {error && show && <div className="text-danger ft-12"> {errorMsg || 'Field is required'}</div>}
            </div>
        </React.Fragment>
    );
}

export default TextInput;
